/**
 * @fileoverview DELETE handler for the "/apps/business/account_fields" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsBusinessAccountFieldsCacheKeys } from "./constants";
import type { DeleteAppsBusinessAccountFieldsProps } from "./types";

export const deleteAppsBusinessAccountFields = reactQueryMutationAdapter(
  appsBusinessAccountFieldsCacheKeys,
  (props: DeleteAppsBusinessAccountFieldsProps): Promise<void> => {
    return fetch("/apps/business/account_fields", "DELETE", props, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
